import { clearSessionIdCache } from '@fs/zion-session'
import { setLocalePreference } from '@fs/zion-locale'
import setCookie, { deleteCookie, extractRootDomain } from './cookie'
import { setSessionStorageItem } from './sessionStorage'
import { clearSessionCaches } from './sessionCaches'

export default function cleanupCenterUser(resetContainerSession) {
  const domain = extractRootDomain(window.location.href)
  deleteCookie('fssessionid', domain)
  deleteCookie('fslanguage', domain)
  setSessionStorageItem({ nonstandardUser: { initialized: false } })
  setSessionStorageItem({ customCountry: null })
  clearSessionIdCache()
  sessionStorage.clear()
  // in-memory per-user caches (e.g. ancestor ordinances) must not outlive the visitor
  clearSessionCaches()

  if (resetContainerSession) {
    // When in kioware, we want the option to clear out all the cookies that could have previous users logged in for facebook, google, church account, etc
    if (window?.KioApp?.EndSession) {
      window.KioApp.EndSession()
    }
  }
}

export const updateFSSessionId = (fssessionid) => {
  clearSessionIdCache() // We don't want axios to use any old cached session ids
  setCookie('fssessionid', fssessionid)
}

export const updateLanguage = (language) => {
  setLocalePreference(language)
}
